"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadExternalRegistry = exports.getRegistryManifestURL = exports.getRegistryBundleID = exports.EXTERNAL_REGISTRY_OVERRIDE_NAMESPACE = void 0;
const createException_1 = require("../createException");
exports.EXTERNAL_REGISTRY_OVERRIDE_NAMESPACE = 'registry';
function getRegistryBundleID(host) {
    return `${host}Registry`;
}
exports.getRegistryBundleID = getRegistryBundleID;
function getRegistryManifestURL(baseURL) {
    return `${baseURL}/registry-manifest.min.json`;
}
exports.getRegistryManifestURL = getRegistryManifestURL;
function loadExternalRegistry({ resourceLoader, url, host, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield resourceLoader.fetch({
            url: getRegistryManifestURL(url),
        });
        const manifest = JSON.parse(response);
        const id = getRegistryBundleID(host);
        if (!manifest[`${id}.js`]) {
            throw createException_1.createException(createException_1.RegistryErrorCode.NoRegistryOverrideForHost);
        }
        const loadBundle = resourceLoader.createBundleLoader({ environment: {} });
        const runtimeURL = manifest['webpack-runtime.js'];
        if (runtimeURL) {
            yield loadBundle({
                url: runtimeURL,
            });
        }
        const bundleUrl = manifest[`${id}.js`];
        const registry = yield loadBundle({
            url: bundleUrl,
            id,
        });
        return registry.default;
    });
}
exports.loadExternalRegistry = loadExternalRegistry;
//# sourceMappingURL=loadExternalRegistry.js.map